module.exports = __webpack_public_path__ + "img/oversecured_image_presentation.76f73460.png";